/**
 * 角色行三枚「列表口不投、详情口才投」的字段：数据范围／端绑定／外部身份（t83）。
 *
 * 列表口只投 id／name／description／status／userCount／code／builtIn／permVersion 八枚；这三枚只有
 * 单角色详情口才投。合并口径收在这里**一处**，⛔ 各处自己挑字段——挑漏一枚就有一条腿静默失效。
 *
 * 两条纪律：
 * 1. 详情缺读（请求失败或还没到货）⇒ **原样返回**（三枚仍为 undefined），⛔ 不拿 false／空数组顶。
 *    把「没读到」画成「没有外部身份／没绑端」就是新的假象，而下游确有按它判的闸。
 * 2. 详情到货但某枚形态不认识 ⇒ 该枚留 undefined；只有形态明确才写值（端绑定显式 null＝未绑端 ⇒ 空数组）。
 */
export interface RoleRowDetailFields {
  dataScope?: string;
  endBinding?: string[];
  isExternal?: boolean;
}

/** 详情口那三枚的原始形态（可能缺键、可能给 null；都用 unknown 收，由本函数判形） */
export interface RoleDetailFieldInput {
  dataScope?: unknown;
  endBinding?: unknown;
  isExternal?: unknown;
}

export function mergeRoleDetailFields<T extends object>(
  row: T,
  detail: RoleDetailFieldInput | null | undefined,
): T & RoleRowDetailFields {
  if (!detail) return row as T & RoleRowDetailFields;
  const merged: RoleRowDetailFields = {};
  if (typeof detail.dataScope === 'string' && detail.dataScope !== '') merged.dataScope = detail.dataScope;
  if (Array.isArray(detail.endBinding)) {
    merged.endBinding = detail.endBinding.filter((end): end is string => typeof end === 'string');
  } else if (detail.endBinding === null) {
    // 显式 null＝未绑端（后端列语义），与「没读到」不是一回事
    merged.endBinding = [];
  }
  if (typeof detail.isExternal === 'boolean') merged.isExternal = detail.isExternal;
  return { ...row, ...merged };
}
